import { createContext, useContext } from "react";
import type { SupportMessageView, SupportSessionView } from "./types";

export interface SupportContextValue {
  enabled: boolean;
  loading: boolean;
  sending: boolean;
  isOpen: boolean;
  unreadCount: number;
  session: SupportSessionView | null;
  messages: SupportMessageView[];
  openWidget: () => void;
  closeWidget: () => void;
  toggleWidget: () => void;
  sendMessage: (args: { text: string; clientMessageId: string }) => Promise<void>;
  markRead: () => Promise<void>;
}

const defaultSupportContext: SupportContextValue = {
  enabled: false,
  loading: false,
  sending: false,
  isOpen: false,
  unreadCount: 0,
  session: null,
  messages: [],
  openWidget: () => {},
  closeWidget: () => {},
  toggleWidget: () => {},
  sendMessage: async () => {},
  markRead: async () => {},
};

export const SupportContext = createContext<SupportContextValue | undefined>(undefined);

export const useSupport = () => {
  const context = useContext(SupportContext);
  if (!context) {
    console.warn("useSupport called outside SupportProvider - using disabled support context");
    return defaultSupportContext;
  }
  return context;
};
